var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1110_1329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4066 0H2.59337C1.16114 0 0 1.16114 0 2.59337V21.4066C0 22.8388 1.16114 24 2.59337 24H21.4066C22.8388 24 24 22.8388 24 21.4066V2.59337C24 1.16114 22.8388 0 21.4066 0ZM19.4032 10.4549C17.8839 10.4549 16.476 9.96896 15.3266 9.14396V15.0981C15.3266 18.0721 12.9074 20.4913 9.93384 20.4913C8.78488 20.4913 7.71924 20.1289 6.84324 19.5137C5.45268 18.5375 4.54108 16.9227 4.54108 15.0981C4.54108 12.1246 6.96028 9.70536 9.93384 9.70536C10.1806 9.70536 10.4226 9.72548 10.6605 9.7578V12.7491C10.4306 12.677 10.1871 12.6354 9.93384 12.6354C8.57556 12.6354 7.47108 13.7403 7.47108 15.0981C7.47108 16.0438 8.00716 16.8656 8.7914 17.278C9.1332 17.4583 9.52136 17.5613 9.93384 17.5613C11.2607 17.5613 12.3427 16.506 12.3919 15.1908L12.3966 3.44877H15.3266C15.3266 3.70254 15.3514 3.95068 15.3959 4.1918C15.6028 5.30848 16.2653 6.26592 17.183 6.86476C17.8226 7.28148 18.5848 7.52492 19.4032 7.52492V10.4549Z",
    fill: "#3D1CAF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1110_1329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/Tiktok.f1598ced4311b6833ba3c7e1db31acfe.svg";
export { ForwardRef as ReactComponent };